module.exports = "<app-spinner></app-spinner>\n<router-outlet></router-outlet>\n<app-instance-type></app-instance-type>"